import React from 'react';
import { FileText } from 'lucide-react';
import { motion } from 'framer-motion';

const MentionsLegales = () => {
  const sections = [
    {
      title: 'Éditeur du site',
      content: (
        <div>
          <p className="mb-4">
            IPTV4KFR est une plateforme de services numériques dédiée à la mise à disposition d'un accès centralisé à des contenus de divertissement (chaînes TV, sport, films, séries).
          </p>
          <div className="bg-[#222226] p-4 rounded-lg border border-[#3A3A3D] space-y-2">
            <p><strong className="text-white">Responsable de la publication :</strong> IPTV4KFR</p>
            <p><strong className="text-white">Contact :</strong> Les demandes peuvent être adressées via les moyens de contact indiqués sur le site.</p>
          </div>
        </div>
      )
    },
    {
      title: 'Hébergement',
      content: (
        <p>
          Le site est hébergé par un prestataire professionnel garantissant la disponibilité, la sécurité et la continuité du service.
        </p>
      )
    },
    {
      title: 'Accès au site',
      content: (
        <p>
          L'accès au site est libre. Certaines fonctionnalités nécessitent la création d'un compte utilisateur ou vendeur.
        </p>
      )
    },
    {
      title: 'Responsabilité',
      content: (
        <p>
          IPTV4KFR met tout en œuvre pour assurer un fonctionnement optimal de la plateforme. Toutefois, la responsabilité de l'éditeur ne saurait être engagée en cas d'interruption temporaire, de maintenance ou d'indisponibilité indépendante de sa volonté.
        </p>
      )
    },
    {
      title: 'Propriété intellectuelle',
      content: (
        <p>
          L'ensemble des éléments présents sur le site (textes, visuels, logos, structure) est protégé. Toute reproduction ou utilisation non autorisée est interdite.
        </p>
      )
    }
  ];

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-block p-4 bg-[#FF6B35]/10 rounded-full mb-6">
            <FileText className="h-12 w-12 text-[#FF6B35]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Mentions légales
          </h1>
          <p className="text-[#B8B8BA]">
            Informations sur l'éditeur et les conditions d'utilisation
          </p>
        </motion.div>

        <div className="space-y-8">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
              className="bg-gradient-to-br from-[#1A1A1D] to-[#121214] p-6 rounded-xl border border-white/10"
            >
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center space-x-2">
                <span className="text-[#FF6B35]">•</span>
                <span>{section.title}</span>
              </h2>
              <div className="text-[#E8E8E8] leading-relaxed">
                {section.content}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
